export const features = [
  {
    tag: '01 / Dares',
    title: 'Dares that start with a wink',
    body: 'From gentle & romantic to bold & uninhibited. Pick your heat level and let the dare decide what happens next.',
    meta: '4 heat levels · 200+ dares · New weekly',
  },
  {
    tag: '02 / Roleplay Stories',
    title: 'Roleplay stories for two',
    body: 'Read aloud, make choices, and let the story carry you somewhere you\'ve never been together.',
    meta: '7 stories · Audio narration · 15-30 min each',
  },
  {
    tag: '03 / Couple Quiz',
    title: 'Discover each other\'s fantasies',
    body: 'Take turns answering secretly. Only mutual fantasies are revealed — and they go straight onto your shared Sex Bucket List.',
    meta: '6 categories · 100+ questions · Private answers',
  },
  {
    tag: '04 / Never Have I Ever',
    title: 'Secrets you never shared',
    body: 'The classic game, redesigned for couples. Swipe through prompts and learn things about each other you never expected.',
    meta: 'Swipe gameplay · 300+ prompts · Couple mode',
  },
];
